export const ROADSIDE_SERVICES_CODES = {
  gasStation: 1,
  roadPay: 2,
  parking: 3,
  carWash: 4,
  autoService: 5,
  guard: 6,
  boat: 7,
  railway: 8,
  store: 9,
  cafe: 10,
  truckWash: 11,
  automobileWash: 12,
  evCharging: 13
};
